export default {
  "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contactez nous"])},
  "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer"])},
  "hide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cacher"])},
  "reply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["répondre"])},
  "trail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trail"])}
}